(function(config) {
    'use strict';

    angular.module('sites.services', [
            'ngResource'
        ])
        .factory('siteDataSrvc', siteDataSrvc)

    siteDataSrvc.$inject = ['$resource'];

    function siteDataSrvc($resource) {
        return $resource('', {}, {
            list: {
                method: 'GET',
                url: config.api + '/api/v1/sites/',
            },
            getFieldOpts: {
                method: 'GET',
                url: config.api + '/api/v1/sites/field_opts/',
                params: {
                    ids: '@ids',
                }
            },
            get: {
                method: 'GET',
                url: config.api + '/api/v1/sites/:pk/',
                params: {
                    pk: '@pk'
                }
            },
        });
    }

})(window.config);
